<button (click)="onClick.emit()"
    class="flex-1 flex flex-col items-center justify-center py-2 transition-all duration-200 relative group outline-none focus:outline-none focus-visible:outline-none !ring-0 !shadow-none" style="outline:none;-webkit-tap-highlight-color:transparent" [ngClass]="{
    'text-primary-600 dark:text-primary-400': active,
    'text-surface-400 hover:bg-surface-50 hover:text-surface-600 dark:text-surface-500 dark:hover:bg-surface-800 dark:hover:text-surface-300': !active
  }">
    <!-- Active indicator bar at top -->
    <div class="absolute top-0 left-1/2 -translate-x-1/2 h-[3px] rounded-full bg-primary-600 dark:bg-primary-400 transition-all duration-200"
         [ngClass]="active ? 'w-8 opacity-100' : 'w-0 opacity-0'"></div>
    <div class="relative mb-0.5 transition-transform" [class.scale-110]="active">
        <ng-content></ng-content>
        <span *ngIf="badge > 0"
            class="absolute -top-1 -right-2 bg-danger-500 text-white text-[10px] font-bold w-4 h-4 flex items-center justify-center rounded-full border border-white dark:border-surface-900">
            {{ badge }}
        </span>
    </div>
    <span class="text-[9px] font-medium uppercase truncate max-w-full px-0.5">
        {{ label }}
    </span>
</button>
